/**
 * EU-353 — flag transiente "acabei de me cadastrar agora".
 *
 * A tela "Sua conta foi criada!" (`/onboarding` index, `OnboardingWelcome`) deve
 * aparecer EXCLUSIVAMENTE logo após um cadastro real (RN-01) — nunca como destino
 * de um login de conta existente. Como a decisão de rota é por
 * `onboarding_progress.status` e uma conta existente SEM linha cai no default
 * `not_started` (igual a um signup novo), não dá pra distinguir os dois só pelo
 * status. Este flag faz essa distinção:
 *
 *  - `markJustSignedUp()` é chamado por `openCandidateRegistration` ANTES de
 *    redirecionar pro registro do Keycloak. O `sessionStorage` sobrevive ao
 *    round-trip pro IdP e de volta (mesma aba/origem), então ao retornar
 *    autenticado o app sabe que veio do cadastro.
 *  - `peekJustSignedUp()` é lido (sem remover) pelo `OnboardingLayout`: só mostra
 *    a welcome quando há flag E `status === 'not_started'`.
 *  - `clearJustSignedUp()` é chamado ao sair da welcome (CTA "Preencher perfil"),
 *    tornando a tela one-shot. O flag é por-aba (sessionStorage), some ao fechar.
 */
const JUST_SIGNED_UP_KEY = 'eureca_just_signed_up';

export function markJustSignedUp(): void {
  try {
    sessionStorage.setItem(JUST_SIGNED_UP_KEY, '1');
  } catch {
    /* private mode / SSR — degrade silently */
  }
}

export function peekJustSignedUp(): boolean {
  try {
    return sessionStorage.getItem(JUST_SIGNED_UP_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearJustSignedUp(): void {
  try {
    sessionStorage.removeItem(JUST_SIGNED_UP_KEY);
  } catch {
    /* private mode / SSR — degrade silently */
  }
}
